export class SESSION_STORAGE_KEY_PREFIXES {
  static readonly gridServer = 'GRID-SERVER';
  static readonly gridClient = 'GRID-CLIENT';
}
